import { useId } from "react"

interface Choice<Value> {
  value: Value
  label: string
}

interface Props<Value> {
  // The ids of the option row's name and hint.
  labelId: string
  hintId: string
  choices: Choice<Value>[]
  value: Value
  onChange: (value: Value) => void
}

// One of a few values, as radios in a pill. The radios show their aria-label as their text.
export const SegmentedControl = <Value extends string>({
  labelId,
  hintId,
  choices,
  value,
  onChange,
}: Props<Value>) => {
  const id = useId()

  return (
    <div
      role="radiogroup"
      aria-labelledby={labelId}
      aria-describedby={hintId}
      className="tabs-box tabs shrink-0 flex-nowrap rounded-full tabs-xs"
    >
      {choices.map((choice) => (
        <input
          key={choice.value}
          type="radio"
          name={id}
          aria-label={choice.label}
          checked={value === choice.value}
          onChange={() => onChange(choice.value)}
          className="tab rounded-full px-2.5 font-bold checked:bg-neutral checked:text-neutral-content"
        />
      ))}
    </div>
  )
}
